module.exports = __webpack_public_path__ + "static/gb-3a9468b2f4f9e9b74fb3b6c85c86a8e9.png";